// import Vue from 'vue'
// import App from './App.vue'
//
// Vue.config.productionTip = false
//
// new Vue({
//   render: h => h(App),
// }).$mount('#app')
//
//


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import qs from 'qs'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { VueJsonp } from 'vue-jsonp'    // 有时候不加{}，会报错
import VueClipboard from 'vue-clipboard2'    // 引入

import moment from 'moment'     //日期时间转换
import axios from "./api/api";

import UtilLz from "./common/utilLz.js";

import '@/assets/iconfont/iconfont.css'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import Print from 'vue-print-nb';
Vue.use(Print);
// import Base64 from 'js-base64'
// Vue.use(Base64)
const Base64 = require('js-base64').Base64

Vue.prototype.$moment = moment;
Vue.prototype.$axios = axios;//请求接口api

Vue.prototype.$utilLz = UtilLz;

Vue.use(ElementUI,VueJsonp,VueClipboard);

Vue.use(Viewer);
Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "title": false, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});

Vue.prototype.$qs = qs
Vue.config.productionTip = false
new Vue({

  router,
  store,
  Base64,
  render: h => h(App)
}).$mount('#app')
